// Meet sidebar — extends shared-gov's AppSidebar shell. Top slot has the
// "New call" button; Middle slot lists the user's rooms (with a live "in
// progress" indicator for rooms that have unended participants).
// PeopleSection is hidden — meet's primary surface is rooms, not people.

export const MeetSidebar = {
  extends: 'AppSidebar',
  PeopleSection: null,

  Top: {
    flow: 'y',
    padding: '0',
    gap: 'Z1',

    NewRoomBtn: {
      tag: 'button',
      text: '+ New call',
      padding: 'Z A',
      round: 'Z',
      border: 'none',
      theme: 'primary',
      cursor: 'pointer',
      fontSize: 'Z2',
      fontWeight: '600',
      ':hover': { opacity: '.9' },
      onClick: (e, el, s) => {
        s.root?.update({
          showNewRoom: true,
          newRoomDraft: {
            name: '',
            kind: 'room',
            isPrivate: false,
            transcribeEnabled: true
          }
        })
      }
    }
  },

  Middle: {
    flow: 'y',
    gap: 'B',

    RoomsGroup: {
      flow: 'y',
      gap: 'Z',

      Header: {
        flow: 'x',
        align: 'center left',
        gap: 'V',
        padding: 'V 0',

        CaptionTitle: {
          fontSize: 'Y2',
          flex: '1',
          Text: { text: 'CALLS' }
        }
      },

      List: {
        extends: 'MeetRoomList'
      }
    }
  }
}
